module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_4star-RGB.b94396ea.svg";